import { ButtonDelete } from '@engloba-tech/englobity';
import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useButtonStyles } from '../button.styles';

export function PackagingButtonDelete({ disabled, tooltip, text, onClick, ...props }) {
  const { t } = useTranslation();
  const classes = useButtonStyles();
  const textButton = text || t('actions.remove');

  const renderButton = () => {
    return (
      <ButtonDelete
        disabled={disabled}
        text={text || t('actions.remove')}
        className={classes.buttonDelete}
        tooltip={
          tooltip
            ? { ...tooltip, title: tooltip.title || textButton }
            : {
                title: textButton,
                placement: 'top'
              }
        }
        onClick={onClick}
      />
    );
  };

  return renderButton();
}

PackagingButtonDelete.propTypes = {
  disabled: PropTypes.bool,
  tooltip: PropTypes.object,
  onClick: PropTypes.func,
  icon: PropTypes.object,
  text: PropTypes.string
};
